import { SET_DIGITAL_FINGERPRINT } from './mutationTypes';

export default {
  [SET_DIGITAL_FINGERPRINT](store, data = {}) {
    store.data = data;
  },
};
